

export enum MESSAGE_STAGE_ENUM {
    /**
     * @description
     * Quando a tarefa é de avaliar uma comunicação criada.
     * @target
     * Aprovador
     */
    AVALIAR_CRIACAO = 'Avaliar Criação',
    /**
     * @description
     * Quando a tarefa é de ajustar uma comunicação criada.
     * @target
     * Criador
     */
    AJUSTAR_CRIACAO = 'Ajustar',
    /**
     * @description
     * Quando a data limite excede enquanto o aprovador não avaliou.
     * @target
     * Aprovador
     */
    AVALIAR_DATA_LIMITE_EXCEDIDA_APROVADOR = 'Data limite excedida para avaliar',
    /**
     * @description
     * Quando a data limite excede enquanto o criador não ajustou uma reprovação
     * @target
     * Criador
     */
    AJUSTE_DATA_LIMITE_EXCEDIDA_CRIADOR = 'Data limite excedida para ajustar',

    /**
     * @description
     * Quando a data limite excede enquanto o lojista não respondeu 
     * @target
     * Criador
     */
    AJUSTE_DATA_LIMITE_EXCEDIDA_LOJISTA = 'Data limite excedida para lojista responder',
    /**
     * @description
     * Quando a tarefa é de responder.
     * @target
     * Lojista
     */
    RESPONDER = 'Responder',
    /**
     * @description
     * Quando a tarefa é de avaliar resposta.
     * @target
     * Aprovador
     */
    AVALIAR_RESPOSTA = 'Avaliar Resposta',
    /**
     * @description
     * Quando esta em processo de criação.
     * @target
     * Criador
     */
    PREVIEW = 'Preview',
    /**
     * @description
     * Quando não é uma tarefa, apenas visualização (Comunicado).
     * @target
     * All
     */
    VISUALIZACAO = 'Visualização',
    /**
     * @description
     * Quando a tarefa é de confirmar o envio da notificação
     * @target
     * Criador da notificação
     */
    CONFIRMAR_NOTIFICACAO = 'Confirmar Envio da Notificação',

}